<ng-container *ngIf="transactions$ | async as transactions">
  <ng-container *ngIf="transactions$ | async as transactions">
    <div *ngFor="let day of transactions | keyvalue : keepOrder">
      <h5 class="transaction-date my-2">{{ day.key | date : 'MMM dd, YYYY' }}</h5>
      <div class="my-1">
        <div class="card my-3 py-2 px-4 bg-tertiary" *ngFor="let transaction of day.value">
          <div class="row">
            <div class="col-8 text-start">
              <div class="fw-bold text-white transaction-text mb-1">
                {{ transaction.TransactionDescription }}
              </div>

              <div class="transaction-subtext fw-bold text-white">
                {{ transaction.TransactionDateUTC | UtcToLocaltimePipe : 'hh:mm a' | uppercase }}
              </div>
            </div>
            <div class="col-4 text-end">
              <div
                class="fw-bold transaction-point text-capitalize"
                [ngClass]="transaction.Amount >= 0 ? 'text-success' : 'text-danger'"
              >
                {{ transaction.Amount >= 0 ? '+' : ''
                }}{{ transaction.Amount | FortressCurrencyPipe : (transactionType === transactionTypes.loyalty ? 'PTS' : 'USD') }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ng-container *ngIf="!transactions || !hasTransactions">
      <div class="card mt-4 bg-tertiary">
        <div class="font-size-14 text-white h-100 d-flex flex-column align-items-center justify-content-center">
          <div
            class="svg svg-info vs-svg ms-auto me-auto"
            fgbAnimateSvg
            [inlineSVG]="'assets/images/placeholders/no-activity.svg'"
          ></div>
          {{ 'account.activity.placeholder.list.description' | translate }}
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
<div *ngIf="loading" class="mt-4">
  <fgbcl-loading></fgbcl-loading>
</div>
